import React from 'react';
import {EnrollmentFileStatusType} from 'Enrollment/models/EnrollmentFileStatusType';
import {EnrollmentFileStatus} from 'Enrollment/api/api';

type BrokerSpreadsheetStatusProps = {
  fileStatus: EnrollmentFileStatus;
  invalidRecordCount: number;
  validRecordCount: number;
  rowCount: number;
  fileStatusIdBeforeCanceled: number;
};
export const BrokerSpreadsheetStatus = ({
  fileStatus,
  invalidRecordCount,
  validRecordCount,
  rowCount,
  fileStatusIdBeforeCanceled,
}: BrokerSpreadsheetStatusProps) => {
  const getActiveClassName = (id: number, invalidRecordCount: number, validRecordCount: number, rowCount: number) => {
    if (EnrollmentFileStatusType.Returned === id) return 'enrollment-file-status-label--unsuccessful';
    if (
      id === EnrollmentFileStatusType.VALIDATION_COMPLETE ||
      id === EnrollmentFileStatusType.RECEIVED ||
      EnrollmentFileStatusType.PROCESSING ||
      EnrollmentFileStatusType.COMPLETED
    ) {
      if (id === EnrollmentFileStatusType.PROCESSING) return 'enrollment-file-status-label--processing-complete';
      else if (rowCount === validRecordCount) return 'enrollment-file-status-label--successful';
      else if (rowCount === invalidRecordCount) return 'enrollment-file-status-label--unsuccessful';
      else if (invalidRecordCount > 0) return 'enrollment-file-status-label--unsuccessful';
      else return 'enrollment-file-status-label--successful';
    }
  };

  const getActiveIcon = (id: number, invalidRecordCount: number, validRecordCount: number, rowCount: number) => {
     if (EnrollmentFileStatusType.Returned === id) return 'fas fa-times-circle upload__status status__unsuccessful';
    if (
      id === EnrollmentFileStatusType.VALIDATION_COMPLETE ||
      id === EnrollmentFileStatusType.RECEIVED ||
      EnrollmentFileStatusType.PROCESSING ||
      EnrollmentFileStatusType.COMPLETED
    ) {
      if (id === EnrollmentFileStatusType.PROCESSING) return 'far fa-circle upload__status status__processing';
      else if (rowCount === validRecordCount) return 'fas fa-check-circle upload__status status__successful';
      else if (rowCount === invalidRecordCount) return 'fas fa-times-circle upload__status status__unsuccessful';
      else if (invalidRecordCount > 0) return 'fas fa-times-circle upload__status status__unsuccessful';
      else return 'fas fa-check-circle upload__status status__successful';
    }
  };

  switch (fileStatus.id) {
    case EnrollmentFileStatusType.VALIDATION_COMPLETE:
    case EnrollmentFileStatusType.RECEIVED:
      return (
        <span
          id="enrollment-file-status-label-received"
          className={getActiveClassName(fileStatus.id, invalidRecordCount, validRecordCount, rowCount)}
        >
          <span className="icon">
            <i className={getActiveIcon(fileStatus.id, invalidRecordCount, validRecordCount, rowCount)} />
          </span>
          Received
        </span>
      );
    case EnrollmentFileStatusType.PROCESSING:
      return (
        <span
          id="enrollment-file-status-label-in-progress"
          className={getActiveClassName(fileStatus.id, invalidRecordCount, validRecordCount, rowCount)}
        >
          <span className="icon">
            <i className={getActiveIcon(fileStatus.id, invalidRecordCount, validRecordCount, rowCount)} />
          </span>
          Processed
        </span>
      );
    case EnrollmentFileStatusType.COMPLETED:
      return (
        <span
          id="enrollment-file-status-label-processing-complete"
          className={getActiveClassName(fileStatus.id, invalidRecordCount, validRecordCount, rowCount)}
        >
          <span className="icon">
            <i className={getActiveIcon(fileStatus.id, invalidRecordCount, validRecordCount, rowCount)} />
          </span>
          Confirmed
        </span>
      );
    case EnrollmentFileStatusType.CANCELED:
      return (
        <span id="enrollment-file-status-label-canceled" className="enrollment-file-status-label--canceled">
          Cancelled
        </span>
      );
      case EnrollmentFileStatusType.Returned:
      return (
        <span
          id="enrollment-file-status-label-received"
          className={getActiveClassName(fileStatus.id, invalidRecordCount, validRecordCount, rowCount)}
        >
          <span className="icon">
            <i className={getActiveIcon(fileStatus.id, invalidRecordCount, validRecordCount, rowCount)} />
          </span>
        {fileStatusIdBeforeCanceled === EnrollmentFileStatusType.RECEIVED ? "Received": "Processed"} 
        </span>
      );  
    default:
      return null;
  }
};
